module.exports = __webpack_public_path__ + "img/myaccount-bg.c0c68b3a.jpg";